import { render, staticRenderFns } from "./MarketingObjectBasics.vue?vue&type=template&id=2816ea8e&scoped=true"
import script from "./MarketingObjectBasics.vue?vue&type=script&lang=js"
export * from "./MarketingObjectBasics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2816ea8e",
  null
  
)

export default component.exports